/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindProductsStandardsQueryResponse,
  FindProductsStandardsQueryParams,
} from "../types/FindProductsStandards.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findProductsStandardsQueryKey = (
  params: FindProductsStandardsQueryParams
) =>
  [
    { url: "/v1/product/find-products-standards" },
    ...(params ? [params] : []),
  ] as const

export type FindProductsStandardsQueryKey = ReturnType<
  typeof findProductsStandardsQueryKey
>

/**
 * @summary Find products custom fields
 * {@link /v1/product/find-products-standards}
 */
export async function findProductsStandards(
  params: FindProductsStandardsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductsStandardsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-products-standards`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductsStandardsQueryOptions(
  params: FindProductsStandardsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductsStandardsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductsStandardsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductsStandardsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductsStandards(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find products custom fields
 * {@link /v1/product/find-products-standards}
 */
export function useFindProductsStandards<
  TData = ResponseConfig<FindProductsStandardsQueryResponse>,
  TQueryData = ResponseConfig<FindProductsStandardsQueryResponse>,
  TQueryKey extends QueryKey = FindProductsStandardsQueryKey,
>(
  params: FindProductsStandardsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductsStandardsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findProductsStandardsQueryKey(params)

  const query = useQuery(
    {
      ...findProductsStandardsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
